import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { AppStore, AppStoreState } from './app.store';

@Injectable({ providedIn: 'root' })
export class AppQuery extends Query<AppStoreState> {
  constructor(readonly appStore: AppStore) {
    super(appStore);
  }

  readonly loading$: Observable<boolean> = this.selectLoading();
  readonly statusDescription$: Observable<string> = this.select((st) => st.status?.message || '');

  isLoading() {
    return this.getValue().loading;
  }
}
